 
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Label, ErrorWrapper, MarkdownPreviewTextarea } from '../../form';

function MarkdownField({ label, name, validate, rows, users, disabled, onMentionAdd }) {
  function Input({ input, meta }) {
    return (
      <>
        <Label htmlFor={name} style={{ width: '100%', fontWeight: 500 }}>
          {label || name}
        </Label>
        <ErrorWrapper touched={meta.touched} error={meta.error}>
          <MarkdownPreviewTextarea
            disabled={disabled}
            users={users}
            name={name}
            {...input}
            rows={rows}
            resize={false}
            onMentionAdd={onMentionAdd}
          />
        </ErrorWrapper>
      </>
    );
  }
  return <Field name={name} render={Input} validate={validate} />;
}

MarkdownField.defaultProps = {
  label: undefined,
  rows: 3,
  validate: () => {},
  disabled: false,
};

MarkdownField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  validate: PropTypes.func,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  onMentionAdd: PropTypes.func,
};

export default MarkdownField;
